import { PROFILE_TYPES } from '@/constants/profiles.const';

export const isPersonalProfile = type => type === PROFILE_TYPES.personal;

export const isBusinessProfile = type => type === PROFILE_TYPES.business;
